export enum DataTables {
  NIF = "NIF",
  OTHER_DOCS = "OTHERDOC",
  TELF = "TELEFONO",
  MAIL = "CORREO",
  USER_NAME = "USUARIO",
  PROMO_CODE = "VOUCHER",
}
